import apiClient from '../apiClient';
import { DELETE_RESTAURANT_ITEM_BY_ID_URL } from '../apiUrl';

const deleteRestaurantItemByIdApi = Id => {
  return apiClient.delete(DELETE_RESTAURANT_ITEM_BY_ID_URL(Id));
};

export default deleteRestaurantItemByIdApi;
